import { DealerStrategiesEnum } from "./constants";

export function checkIfVariableStrategyChanged(variable1, variable2) {
  return variable1.margin !== variable2.margin || variable1.minimum !== variable2.minimum;
}

export function checkIfResidentialStrategyChanged(variable1, variable2) {
  return variable1.margin !== variable2.margin;
}

export function checkIfCostPlusStrategyChanged(costPlus1, costPlus2) {
  return costPlus1.amount !== costPlus2.amount;
}

export function checkIfStrategyChanged(strategy1, strategy2) {
  if ((strategy1 === undefined || strategy1 === null) && (strategy2 === undefined || strategy2 === null)) {
    return false;
  }

  if (strategy1?.strategyType !== strategy2?.strategyType) {
    return true;
  }

  switch (strategy1.strategyType) {
    case DealerStrategiesEnum.Variable:
      return checkIfVariableStrategyChanged(strategy1, strategy2);

    case DealerStrategiesEnum.Residential:
      return checkIfResidentialStrategyChanged(strategy1, strategy2);

    case DealerStrategiesEnum.CostPlus:
      return checkIfCostPlusStrategyChanged(strategy1, strategy2);
  }

  return false;
}

function checkIfCostPlusStrategyIsValid(strategy) {
  const { amount } = strategy;
  const isANumber = typeof amount === "number" && !isNaN(amount);
  const withinRange = amount > 0;

  return isANumber && withinRange;
}

function checkIfVariableStrategyIsValid(strategy) {
  const { margin } = strategy;
  const isANumber = typeof margin === "number" && !isNaN(margin);
  const withinRange = margin > 0 && margin <= 100;

  return isANumber && withinRange;
}

function checkIfResidentialStrategyIsValid(strategy) {
  const { margin } = strategy;
  const isANumber = typeof margin === "number" && !isNaN(margin);
  const withinRange = margin > 0 && margin <= 100;

  return isANumber && withinRange;
}

export function checkIfStrategyIsValid(strategy) {
  if (strategy === undefined || strategy === null) {
    return false;
  }

  switch (strategy.strategyType) {
    case DealerStrategiesEnum.CostPlus:
      return checkIfCostPlusStrategyIsValid(strategy);

    case DealerStrategiesEnum.Variable:
      return checkIfVariableStrategyIsValid(strategy);

    case DealerStrategiesEnum.Residential:
      return checkIfResidentialStrategyIsValid(strategy);
  }

  return true;
}
